import { Component, OnInit } from '@angular/core';
import { ValidationService } from '../../../shared/services/validation.service';
import { NumberModel } from '../../../model/user/number.model';
import { ActivatedRoute, Router } from '@angular/router';
import { NzModalRef, NzModalService } from 'ng-zorro-antd';
import { AccountSuspensionComponent } from '../../../shared/notification/account-suspension/account-suspension.component';
import { SessionService } from '../../../shared/services/session.service';
import { MaskUtil } from '../../../shared/utils/star-masking-util';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TextService } from '../../../shared/services/text.service';
import { SdkInitText } from 'src/app/model/user/sdk-init-text';
import { NetmeraService } from "../../../shared/services/netmera-service";
import { Login } from "../../../model/netmera-events/login";
import { Error } from "../../../model/netmera-events/error";

@Component({
  selector: 'pa-pin-entry',
  templateUrl: './pin-entry.component.html',
  styleUrls: ['./pin-entry.component.scss']
})
export class PinEntryComponent implements OnInit {
  phoneNumber: string;
  submitted = false;
  pinForm = new FormGroup({
    pin: new FormControl('', [Validators.required, Validators.minLength(4)])
  });
  numberModel: NumberModel;
  tplModal: NzModalRef;
  errorMessage: string;
  textService: TextService;
  trackingId: string;
  merchantCode: string;
  sdkInitTexts: Array<SdkInitText>;

  constructor(private router: Router, private route: ActivatedRoute, private validationService: ValidationService, private sessionService: SessionService,
              private modalService: NzModalService, textService: TextService, private netmeraService: NetmeraService, private login: Login, private error: Error) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
      this.numberModel = new NumberModel();
      this.sessionService.getInitUser(this.trackingId).subscribe(response => {
        if (response != null) {
          this.sdkInitTexts = response.sdkInitTexts;
          this.phoneNumber = MaskUtil.MaskingConfiguration(response.msisdn, 3, 6);
          this.merchantCode = response?.requestHeader?.merchant?.merchantCode;
          this.netmeraService.pushEvent(this.login.setEventObject("PinGirisEkrani", this.merchantCode));
        }
      }, error => {
        this.router.navigate(['/result/error', this.trackingId]);
      });
    });
  }

  checkPin() {
    this.submitted = true;
    if (this.pinForm.invalid) {
      return;
    }
    this.numberModel.partOfOne = this.pinForm.value.pin;
    this.validationService.checkPin(this.numberModel, this.trackingId).subscribe(response => {
      if (response.numberModel.pinSuspend) {
        this.accountSuspend();
      } else {
        this.netmeraService.pushEvent(this.login.setEventObject("PinBasarili", this.merchantCode));
        this.router.navigate(['/route', this.trackingId]);
      }
    }, error => {
      this.netmeraService.pushEvent(this.login.setEventObject("PinBasarisiz", this.merchantCode));
      this.netmeraService.pushEvent(this.error.setEventObject("PinBasarisiz", this.merchantCode));
      if (error.status == 422) {
        this.pinForm.reset();
        this.errorMessage = error.error.message;
      } else if (error.error.responseCode == '209') {
        this.router.navigate(['/result/parental-leave-not-ok',this.trackingId,]);
      } else {
        this.router.navigate(['/result/error', this.trackingId]);
      }
    });
  }

  accountSuspend() {
    this.tplModal = this.modalService.create({
      nzClassName: "suspend-modal",
      nzWrapClassName: "vertical-center-modal",
      nzContent: AccountSuspensionComponent,
      nzMaskClosable: true,
      nzClosable: true,
      nzFooter: null,
      nzStyle: {
        width: '513px',
        height: '422px',
        'border-radius': '15px',
        'box-shadow': '0 0 15px 0 rgba(0, 0, 0, 0.25)',
        'background-color': '#ffffff'
      },
      nzComponentParams: {trackingId: this.trackingId}
    });
  }

  messageState(value: any) {
    this.errorMessage = value;
  }

}
